<template>
  <div>
    <div class="flex flex-col items-center justify-center">
      <h1 class="text-3xl font-bold mb-4">Podcasts</h1>
      <p class="text-lg mb-4">Explore our collection of podcasts.</p>
      <div class="flex flex-wrap justify-center">
        <div class="row">
          <template v-for="podcast in podcasts">
            <div
              class="col-12 col-md-6 col-lg-4 d-flex mb-5"
              :key="podcast.id"
              v-if="podcast.snippet.title != 'Private video'"
            >
              <!-- Card -->
              <div class="card mb-6 mb-lg-0 shadow-light-lg">
                <!-- Image -->
                <a
                  class="card-img-top"
                  target="_blank"
                  :href="`https://www.youtube.com/watch?v=${podcast.snippet.resourceId.videoId}`"
                >
                  <img
                    :src="podcast.snippet.thumbnails.standard.url"
                    alt="..."
                    class="card-img-top"
                  />
                </a>
                <!-- Shape -->
                <div class="position-relative">
                  <div class="shape shape-fluid-x shape-bottom text-white">
                    <svg
                      viewBox="0 0 2880 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </div>
                </div>
                <!-- Body -->
                <a
                  class="card-body"
                  target="_blank"
                  :href="`https://www.youtube.com/watch?v=${podcast.snippet.resourceId.videoId}`"
                >
                  <h3>{{ podcast.snippet.title }}</h3>
                </a>
                <!-- Meta -->
                <a
                  class="card-meta"
                  target="_blank"
                  :href="`https://www.youtube.com/watch?v=${podcast.snippet.resourceId.videoId}`"
                >
                  <!-- Divider -->
                  <hr class="card-meta-divider" />
                  <!-- Author
                  <h6 class="text-uppercase text-body-secondary me-2 mb-0">
                    {{ podcast.snippet.description }}
                  </h6> -->
                  <!-- Date -->
                  <p class="h6 text-uppercase text-body-secondary mb-0 ms-auto">
                    <time>{{ podcast.snippet.publishedAt }}</time>
                  </p>
                </a>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div v-if="loading" class="text-center">
        <p>Loading...</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Podcasts",
  data() {
    return {
      podcasts: [],
      loading: true,
    };
  },
  components: {
    // PodcastCard: () => import("@/components/PodcastCard.vue"),
  },
  mounted() {
    let self = this;
    self.axios
      .get(
        "https://youtube.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=PL0iYYMFaki_2yferW0QI7pKBVSfbSUJAE&maxResults=50&key=AIzaSyCfd5Y4W7hZrhnoKCnm4Gwy2AbrI73RNrE"
      )
      .then((response) => {
        self.podcasts = response.data.items;
        self.loading = false;
        console.log(self.podcasts);
      });
  },
};
</script>